import styled from 'styled-components';
import { Link } from 'react-router-dom';
import noticeIcon from '../../assets/notice.png';
import attachIcon from '../../assets/attach.png';
import formatDate from '../../utils/formatDate';

const ItemListItem = ({ item, order, index }) => {
  const isNotice = !!item.isPublic;

  return (
    <Row>
      <NumberCell>
        {isNotice ? (
          <ImportantBadge aria-label="공지">공지</ImportantBadge>
        ) : (
          <NumberText>{index}</NumberText>
        )}
      </NumberCell>

      <TitleCell>
        <TitleLink to={order + item.id}>
          <TitleText>{item.title}</TitleText>
          {item.files ? <AttachIcon src={attachIcon} alt="첨부파일" /> : null}
        </TitleLink>
      </TitleCell>

      <WriterGroup>
        <WriterLabel>작성자</WriterLabel>
        <WriterText>{item?.writer?.username ?? ''}</WriterText>
        <DateLabel>등록일</DateLabel>
        <DateText>{formatDate(item.createdAt)}</DateText>
      </WriterGroup>

      <DateGroup>
        <DateLabel>등록일</DateLabel>
        <DateText>{formatDate(item.createdAt)}</DateText>
      </DateGroup>
    </Row>
  );
};

export default ItemListItem;

/* styles */
const Row = styled.div`
  box-sizing: border-box;
  width: 100%;
  color: #333333;
  border-bottom: 1px solid #c8c8c8;
  /* 헤더와 동일한 컬럼 정의: 9% | (수축가능) | 21% | 21% */
  display: grid;
  grid-template-columns: 9% minmax(0, 1fr) 21% 21%;
  align-items: center;
  & > * {
    box-sizing: border-box;
  }

  @media (max-width: 767px) {
    /* 모바일: NumberCell | TitleCell
                      | (작성자 등록일) */
    display: grid;
    grid-template-columns: 60px 1fr;
    grid-template-rows: auto auto;
    gap: 4px 8px;
    padding: 3% 0;
    align-items: center;
  }
`;

/* 헤더 9%와 동일 */
const NumberCell = styled.div`
  text-align: center;
  padding: 10px 5px;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 767px) {
    grid-column: 1;
    grid-row: 1 / 3; /* 2줄 span */
    padding: 0;
    width: 60px;
  }
`;

const NumberText = styled.p`
  margin: 0;
  font-size: 20px;
  font-family: 'koPubWorld DotumM';
  @media (max-width: 767px) {
    font-size: 15px;
  }
`;

const ImportantBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: url(${noticeIcon}) center center no-repeat;
  background-size: 46px 30px;
  font-family: 'koPubWorld DotumB';
  font-size: 16px;
  color: #fff;
  width: 46px;
  height: 30px;
  border-radius: 4px;

  @media (max-width: 767px) {
    width: 40px;
    height: 27px;
    background-size: 40px 27px;
    font-size: 15px;
    border-radius: 3px;
  }
`;

/* 헤더 49%와 동일 — 제목은 반드시 수축 가능해야 함 */
const TitleCell = styled.div`
  min-width: 0; /* ★ ellipsis 필수 */
  padding: 10px 5px;
  overflow: hidden;

  @media (max-width: 767px) {
    grid-column: 2;
    grid-row: 1;
    padding: 0;
    text-align: left;
  }
`;

/* 텍스트/아이콘 분리해서 텍스트만 ellipsis */
const TitleLink = styled(Link)`
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0; /* ★ 내부 수축 허용 */
  text-decoration: none;
  color: #333333;
  font-size: 20px;
  font-family: 'koPubWorld DotumB';

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: 767px) {
    font-size: 17px;
  }
`;

/* 한 줄 말줄임을 여기에 적용 */
const TitleText = styled.span`
  flex: 1 1 auto;
  min-width: 0; /* ★ 수축 허용 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; /* ★ 유지 */
`;

const AttachIcon = styled.img`
  flex: 0 0 auto; /* 아이콘은 고정 */
  vertical-align: middle;
`;

/* 헤더 21%와 동일 (작성자) */
const WriterGroup = styled.div`
  padding: 10px 5px;
  text-align: center;

  @media (max-width: 767px) {
    grid-column: 2;
    grid-row: 2;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-size: 13px;
    color: #666666;
    padding: 0;
    text-align: left;
    justify-self: start;
  }
`;

const WriterLabel = styled.span`
  display: none;
  @media (max-width: 767px) {
    display: inline-block;
    font-size: 13px;
    font-family: 'koPubWorld DotumB';
    color: #666666;
    margin-right: 2px;
  }
`;

const WriterText = styled.span`
  font-size: 20px;
  font-family: 'koPubWorld DotumM';
  @media (max-width: 767px) {
    font-size: 13px;
    font-family: 'koPubWorld DotumM';
    color: #666666;
  }
`;

/* 헤더 21%와 동일 (등록일) */
const DateGroup = styled.div`
  padding: 10px 5px;
  text-align: center;

  @media (max-width: 767px) {
    display: none; /* 모바일에서는 WriterGroup에 통합 */
  }
`;

const DateLabel = styled.span`
  display: none;

  /* DateGroup 내부에서만 표시 (데스크톱에서는 label 없음) */
  ${DateGroup} & {
    display: none;
  }

  /* WriterGroup 내부에서는 모바일에서만 보이도록 */
  ${WriterGroup} & {
    display: none; /* 데스크톱에서는 숨김 */

    @media (max-width: 767px) {
      display: inline-block;
      font-size: 13px;
      font-family: 'koPubWorld DotumB';
      color: #666666;
      margin-left: 8px;
      margin-right: 2px;
    }
  }
`;

const DateText = styled.span`
  font-size: 20px;
  font-family: 'koPubWorld DotumM';

  /* WriterGroup 내부에서는 데스크톱에서 숨김, 모바일에서만 보임 */
  ${WriterGroup} & {
    display: none; /* 데스크톱에서는 숨김 */

    @media (max-width: 767px) {
      display: inline-block;
      font-size: 13px;
      font-family: 'koPubWorld DotumM';
      color: #666666;
    }
  }

  /* DateGroup 내부에서는 항상 보임 (모바일에서는 DateGroup 자체가 숨김) */
  @media (max-width: 767px) {
    font-size: 13px;
    font-family: 'koPubWorld DotumM';
    color: #666666;
  }
`;
